/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import {
  ORDER_SUMMARY,
  ORDER_SUMMARY_SUBSCRIPTION,
} from 'pages/Dashboard/components/DashboardGraphQL';
import { defaultFiltersForDates } from 'pages/Dashboard/components/constant';
import { isEmpty } from 'lodash';
import Loader from 'components/common/Loader';
import PermissionNotice from 'pages/Dashboard/components/PermissionNotice';

const OrdersCount = ({ item, selectedOption, canView = true }) => {
  const navigate = useNavigate();
  const { data, loading, error, subscribeToMore } = useQuery(ORDER_SUMMARY, {
    variables: defaultFiltersForDates(selectedOption),
    fetchPolicy: 'network-only',
    skip: !canView,
  });

  useEffect(() => {
    if (!canView) return undefined;
    const unsubscribe = subscribeToMore({
      document: ORDER_SUMMARY_SUBSCRIPTION,
      variables: defaultFiltersForDates(selectedOption),

      updateQuery: (prev, { subscriptionData }) => {
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        return subscriptionData.data;
      },
    });
    return () => unsubscribe();
  }, [canView, selectedOption, subscribeToMore]);

  if (!canView) {
    return (
      <div>
        <Card className="border-0">
          <CardBody>
            <h4 className="f-16 fw-semibold mb-3">{item.title}</h4>
            <PermissionNotice message="You do not have permission to view Orders." />
          </CardBody>
        </Card>
      </div>
    );
  }

  if (error) return `There is an error on this page : ${error.message} `;

  return (
    <div>
      <Card className="border-0 cursor-pointer">
        <CardBody>
          <h4 className="f-16 fw-semibold mb-3">{item.title}</h4>
          {loading ? (
            <div className="text-center mt-4">
              <Loader size="sm" />
            </div>
          ) : (
            <Row className="justify-content-between">
              <Col key={item.subTitle[0].label}>
                <div>
                  <p className="text-active-light mb-0">
                    {item.subTitle[0].label}
                  </p>
                  <p
                    className="mb-0 f-18 fw-medium"
                    onClick={(event) => {
                      event.stopPropagation();
                      navigate('/orders');
                    }}
                    aria-hidden="true"
                  >
                    {data?.ordersSummary?.pending === null
                      ? 0
                      : data?.ordersSummary?.pending}
                  </p>
                </div>
              </Col>
              <Col key={item.subTitle[1].label}>
                <div>
                  <p className="text-active-light mb-0">
                    {item.subTitle[1].label}
                  </p>
                  <p
                    className="mb-0 f-18 fw-medium text-start"
                    onClick={(event) => {
                      event.stopPropagation();
                      navigate('/orders');
                    }}
                    aria-hidden="true"
                  >
                    {data?.ordersSummary?.paid === null
                      ? 0
                      : data?.ordersSummary?.paid}
                  </p>
                </div>
              </Col>
            </Row>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default OrdersCount;
